import * as types from '../mutation-types';

const state = () => ({
	reviews: [],
});

const actions = {
	fetchBranchReviews({commit}, {restaurantId, branchId}) {
		return axios.get(`/api/restaurants/${restaurantId}/branches/${branchId}/reviews`).then(response => {
			commit(types.STORE_REVIEWS, response.data);

			return response.data;
		});
	},

	fetchFoodReviews({commit}, {restaurantId, branchId, foodId}) {
		return axios.get(`/api/restaurants/${restaurantId}/branches/${branchId}/food/${foodId}/reviews`).then(response => {
			commit(types.STORE_REVIEWS, response.data);

			return response.data;
		});
	},
};

const mutations = {
	[types.STORE_REVIEWS](state, reviews) {
		state.reviews = reviews;
	},
};

const getters = {
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};